/*
  ChevronRight.jsx
*/

import React from 'react';
import SvgIcon from '../components/SvgIcon';

export default function ChevronRight(props) {
  return (
    <SvgIcon {...props}>
      <path d="M10 6 8.59 7.41 13.17 12l-4.58 4.59L10 18l6-6z"></path>
    </SvgIcon>
  );
}
